import React from "react";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import styles from "../styles/deleteWarning.module.css";
import dashboardStore from "../store/dashboardStore";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Avatar from "@mui/material/Avatar";

export const DeleteWarningModal = observer(() => {
  const store = dashboardStore;
  const { t } = useTranslation("ActivityMain");

  const handleCancel = () => {
    store._handleSetDeleteIndex(null);
    store._handleSetShowDeleteWarningModal(false);
  };

  const handleDelete = () => {
    store._handleDeleteMetricByIndex(store.deleteIndex);
    store._handleSetDeleteIndex(null);
    store._handleSetShowDeleteWarningModal(false);
  };
  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer} style={{ paddingTop: "32px" }}>
        {/* Icon */}
        <div className={styles.iconWrap}>
          <Avatar sx={{ bgcolor: " rgb(254,226,226)", width: 65, height: 65 }}>
            <WarningRoundedIcon sx={{ fontSize: 46, color: "#ff3b30" }} />
          </Avatar>
        </div>

        {/* Text Section */}
        <div className={styles.textBlock}>
          <div
            className={styles.title}
            style={{ fontSize: "20px", color: "#1a1a1a" }}
          >
            {t("Confirm Deletion")}
          </div>

          <div
            className={styles.subtitle}
            style={{ fontSize: "15px", color: "black", lineHeight: "1.5" }}
          >
            {t("Are you sure you want to delete")}
            <b style={{ fontSize: "20px", color: "#1a1a1a" }}>
              {" "}
              {`${store.metricData[store.deleteIndex]["metricName"]}`}
            </b>{" "}
            ?{/* 新增這段提醒文字 */}
            <div style={{ marginTop: "6px", fontSize: "14px", color: "#444" }}>
              {t("Any unsaved changes will be lost.")}
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className={styles.btnRow}>
          <button className={styles.btnCancel} onClick={handleCancel}>
            {t("Cancel")}
          </button>

          <button
            className={styles.btnSave}
            style={{
              background: "#ff3b30",
              border: "none",
            }}
            onClick={handleDelete}
          >
            {t("Confirm Delete")}
          </button>
        </div>
      </div>
    </div>
  );
});
